import React from "react";
import BackgroundImage from "../common/BackgroundImage";
import { BACKGROUNDS } from "../../config/backgrounds";
import { glassTheme as styles } from "./glassTheme";

export default function HomeShell({
  children,
  background = BACKGROUNDS.dashboard,
  fullHeight = true,
  style,
}) {
  return (
    <div
      style={{
        ...(fullHeight ? styles.container : { position: "relative", width: "100%", color: "#fff", fontFamily: styles.container.fontFamily }),
        ...style,
      }}
    >
      <BackgroundImage image={background} />
      <div style={{ position: "relative", zIndex: 1, flex: fullHeight ? 1 : undefined, display: fullHeight ? "flex" : "block", flexDirection: "column", minHeight: fullHeight ? 0 : undefined }}>
        {children}
      </div>
    </div>
  );
}

export function HomePageContent({ children, wide = false }) {
  return (
    <div
      style={{
        ...styles.pageContent,
        maxWidth: wide ? "1000px" : styles.pageContent.maxWidth,
        paddingBottom: "120px",
      }}
    >
      {children}
    </div>
  );
}
